import React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import SectionTitle from "../../../components/Typography/SectionTitle"
import SectionCategory from "../../../components/Typography/SectionCategory"
import { FormattedMessage } from "react-intl"
import ContentWrapper from "../../../components/Container/ContentWrapper"
import { Locale } from "../../../locale"
import SectionDescription from "../../../components/Typography/SectionDescription"
import usePlatform from "../../../hooks/usePlatform"
import { Grid } from "@material-ui/core"
import eventManagement from "../../../assets/images/analytics/event_management.png"
import eventManagementMo from "../../../assets/images/analytics/event_management_mo.png"
import TypographyWithCheck from "../../../components/Typography/TypographyWithCheck"
import useScrollImpressionLog from "../../../hooks/useScrollImpressionLog"

interface StyleProps {
  isDesktop: boolean
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      background: "#FFF",
    },
    container: {
      background: `url(${eventManagement})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      padding: "48px 20px",
      [theme.breakpoints.up("md")]: {
        padding: "100px 0",
        minHeight: 770,
      },
    },
    advantages: {
      marginTop: 30,
      "& > div": {
        marginBottom: 10,
      },
      [theme.breakpoints.up("md")]: {
        marginTop: 48,
        "& > div": {
          marginBottom: 12,
        },
      },
    },
    grey: {
      color: "rgba(0, 0, 0, .3)",
      fontWeight: 400,
    },
    mobileImg: {
      marginTop: 48,
      width: "100%",
    },
  })
)
export default function EventManagement() {
  const { isDesktop, isMobile } = usePlatform()
  const classes = useStyles({ isDesktop })
  const { lang } = Locale.getDefault()
  const { ref } = useScrollImpressionLog({
    message: "5_0: 데이터 분석 시작 전 이벤트를 먼저 관리해보세요.",
    eventKey: "homepage_data_analytics_detail_section_5_impression",
  })

  return (
    <div className={classes.root} ref={ref}>
      <ContentWrapper>
        <Grid container className={classes.container}>
          <Grid item xs={isDesktop ? 6 : 12}>
            <SectionCategory>
              <FormattedMessage id={"event_management"} />
            </SectionCategory>
            <SectionTitleByLang lang={lang} isDesktop={isDesktop} />
            <SectionDescriptionByLang lang={lang} isDesktop={isDesktop} />
            <Advantages lang={lang} isDesktop={isDesktop} />
          </Grid>
          {isMobile && <img src={eventManagementMo} className={classes.mobileImg} />}
        </Grid>
      </ContentWrapper>
    </div>
  )
}
interface LangProps {
  lang: string
  isDesktop: boolean
}
function SectionTitleByLang({ lang }: LangProps) {
  if (lang === "ko")
    return (
      <SectionTitle>
        데이터 분석 시작 전<br />
        이벤트를 먼저 관리해 보세요.
      </SectionTitle>
    )

  return (
    <SectionTitle>
      Manage your event data
      <br />
      prior to data analytics
    </SectionTitle>
  )
}

function SectionDescriptionByLang({ lang, isDesktop }: LangProps) {
  if (lang === "ko")
    return (
      <SectionDescription>
        핵클은 한 번의 SDK 연동으로 이벤트와 이벤트 속성을 수집할 수 있고,
        {isDesktop && <br />}
        동일 이벤트로 A/B 테스트와 데이터 분석, 기능 플래그까지 동시에 진행할 수 있습니다.
      </SectionDescription>
    )

  return (
    <SectionDescription>
      You can collect events and event attributes with a single SDK {isDesktop && <br />}integration! A/B testing, data
      analysis and feature flag is available simultaneously with same events.
    </SectionDescription>
  )
}

function Advantages({ lang, isDesktop }: LangProps) {
  const classes = useStyles({ isDesktop })
  return (
    <div className={classes.advantages}>
      <TypographyWithCheck>
        <FormattedMessage id={"event_management_real_time"} />
      </TypographyWithCheck>
      <TypographyWithCheck>
        <FormattedMessage id={"event_management_automatic"} /> {lang === "en" && <br />}
        <span className={classes.grey}>
          (<FormattedMessage id={"except_automatic_event"} />)
        </span>
      </TypographyWithCheck>
      <TypographyWithCheck>
        <FormattedMessage id={"event_management_image"} />
      </TypographyWithCheck>
    </div>
  )
}
